import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function PricingSection() {
  return <section id="comprar" className="w-full bg-black text-white py-16 border-t-8 border-yellow-400" data-id="element-201">
      <div className="max-w-3xl mx-auto px-4" data-id="element-202">
        <div className="bg-gray-900 rounded-3xl p-8 md:p-12 border border-gray-800 shadow-2xl relative overflow-hidden" data-id="element-203">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/10 rounded-full blur-3xl" data-id="element-204"></div>

          <h2 className="text-3xl md:text-4xl font-black text-center mb-8 relative z-10" data-id="element-205">
            📦 Lo que recibes hoy
          </h2>

          <div className="space-y-4 text-lg md:text-xl font-medium mb-10 relative z-10" data-id="element-206">
            <p className="flex items-center gap-3" data-id="element-207">
              <span className="text-green-500 text-2xl" data-id="element-208">✔</span> 5 Tomos de
              Actividades Educativas
            </p>
            <p className="flex items-center gap-3" data-id="element-209">
              <span className="text-green-500 text-2xl" data-id="element-210">✔</span> Más de 500
              actividades para imprimir
            </p>
            <p className="flex items-center gap-3" data-id="element-211">
              <span className="text-yellow-400 text-2xl" data-id="element-212">✔</span> Bono #1:
              Aprende Cards
            </p>
            <p className="flex items-center gap-3" data-id="element-213">
              <span className="text-yellow-400 text-2xl" data-id="element-214">✔</span> Bono #2:
              Mindfulness para niños
            </p>
            <p className="flex items-center gap-3" data-id="element-215">
              <span className="text-yellow-400 text-2xl" data-id="element-216">✔</span> Bono #3:
              Aprendo vocales coloreando
            </p>
            <p className="flex items-center gap-3" data-id="element-217">
              <span className="text-yellow-400 text-2xl" data-id="element-218">✔</span> Bono #4:
              Tabla de recompensas
            </p>
            <p className="flex items-center gap-3" data-id="element-219">
              <span className="text-yellow-400 text-2xl" data-id="element-220">✔</span> Bono #5:
              Plantillas para plastilina
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center gap-6 mb-10 text-center relative z-10" data-id="element-221">
            <div className="bg-gray-800 p-4 rounded-xl border border-gray-700" data-id="element-222">
              <span className="text-2xl mb-2 block" data-id="element-223">📥</span>
              <p className="font-bold text-sm" data-id="element-224">Descarga digital inmediata</p>
            </div>
            <div className="bg-gray-800 p-4 rounded-xl border border-gray-700" data-id="element-225">
              <span className="text-2xl mb-2 block" data-id="element-226">📱</span>
              <p className="font-bold text-sm" data-id="element-227">
                Acceso desde cualquier dispositivo
              </p>
            </div>
            <div className="bg-gray-800 p-4 rounded-xl border border-gray-700" data-id="element-228">
              <span className="text-2xl mb-2 block" data-id="element-229">♾</span>
              <p className="font-bold text-sm" data-id="element-230">Acceso de por vida</p>
            </div>
          </div>

          <div className="text-center mb-10 relative z-10" data-id="element-231">
            <p className="text-gray-400 text-xl line-through mb-2" data-id="element-232">
              💰 Precio regular: ARS $49.990
            </p>
            <p className="text-5xl md:text-6xl font-black text-yellow-400 animate-pulse" data-id="element-233">
              🔥 HOY SOLO: ARS $19.990
            </p>
          </div>

          <div className="relative z-10" data-id="element-234">
            <CTAButton text="👉 QUIERO EL MEGA PACK AHORA" className="text-2xl py-5" data-id="element-235" />
          </div>

          <div className="mt-12 pt-8 border-t border-gray-800 text-center relative z-10" data-id="element-236">
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center justify-center gap-2" data-id="element-237">
              <span data-id="element-238">🔒</span> Garantía sin riesgo
            </h3>
            <p className="text-gray-300 mb-2" data-id="element-239">
              Prueba el Mega Pack durante 7 días completos.
            </p>
            <p className="text-gray-300 mb-2" data-id="element-240">
              Si no sientes que las actividades ayudan a estimular el
              aprendizaje de tu hijo, te devolvemos el 100% del dinero.
            </p>
            <p className="text-gray-400 font-bold italic" data-id="element-241">Sin preguntas.</p>
          </div>
        </div>
      </div>
    </section>;
}